import o from "./ghl-ui.es413.js";
import i from "./ghl-ui.es1220.js";
import m from "./ghl-ui.es1495.js";
import f from "./ghl-ui.es1309.js";
function c(r, t) {
  return o(r) ? r : i(r, t) ? [r] : m(f(r));
}
export {
  c as default
};
